"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContainerShape = void 0;

var _native = _interopRequireDefault(require("styled-components/native"));

var _props = require("@sloth-system/props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let PageContainerShape = _native.default.View`
  ${_props.paddingProps}
  ${_props.backgroundColorProps}
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  flex: 1;
`;
exports.PageContainerShape = PageContainerShape;